<template>
  <h-legal-dialog
    url="/privacy-policy"
    :title="__('legalPrivacyPolicy')"
  />
</template>

<script>
  import I18n from '@/Mixins/I18n'
  import HLegalDialog from './ExternalContentDialog'

  export default {
    mixins: [
      I18n,
    ],

    components: {
      HLegalDialog,
    },
  }
</script>
